import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Trash2 } from 'lucide-react';
import SEO from '../components/SEO.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import '../styles/pages/Home.css';

const Home = () => {
  return (
    <>
      <SEO
        title="SAP Movers - Professional Moving Services"
        description="Professional moving and junk removal services. Local and long-distance moves, furniture removal, and same-day service."
        keywords="moving services, junk removal, local movers, long distance moving, furniture removal, professional movers"
        canonical="https://sapmovers.com"
        ogTitle="SAP Movers - Professional Moving Services"
        ogDescription="Professional moving and junk removal services."
      />

      <Header />

      {/* Hero Section */}
      <section className="hero">
        <h1>Professional Moving & Junk Removal Services</h1>
        <p>Full-service support from packing and loading to disposal and sweep-up.</p>
        <div className="hero-cta-container">
          <Link to="/moving" className="cta-button">Get Moving Quote</Link>
          <Link to="/junk-removal" className="cta-button">Schedule Junk Removal</Link>
          
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <h2>Our Services</h2>
        <div className="services-grid">
          <div className="service-card">
            <Truck size={48} color="var(--icon-blue)" style={{ marginBottom: '1rem' }} />
            <h3>Moving Services</h3>
            <p>Professional residential and commercial moving services. Local and long-distance moves with full packing and unpacking services.</p>
            <Link to="/moving" className="service-link">
              Learn More →
            </Link>
          </div>
          
          <div className="service-card">
            <Trash2 size={48} color="var(--icon-primary)" style={{ marginBottom: '1rem' }} />
            <h3>Junk Removal</h3>
            <p>Fast and reliable junk removal services. Same-day pickup available for furniture, appliances, and construction debris.</p>
            <Link to="/junk-removal" className="service-link">
              Learn More →
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="services" style={{ background: '#f8fafc' }}>
        <h2>Why Choose SAP Movers?</h2>
        <div className="services-grid">
          <div className="service-card">
            <h3>Flexible Scheduling</h3>
            <p>Weekend, evening, and short-notice appointments available. We work around your timeline to keep the project smooth.</p>
          </div>
          
          <div className="service-card">
            <h3>Experienced Team</h3>
            <p>Cross-trained crews for moves and cleanouts alike. We protect your items, property, and schedule on every job.</p>
          </div>
          
          <div className="service-card">
            <h3>Competitive Pricing</h3>
            <p>Transparent pricing with no hidden fees. Free estimates and competitive rates for all services.</p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="services">
        <h2>Ready to Get Started?</h2>
        <p style={{ textAlign: 'center', fontSize: '1.2rem', marginBottom: '2rem', color: '#666' }}>
          Contact us today for your free quote on moving or junk removal services.
        </p>
        <div style={{ textAlign: 'center' }}>
          <Link to="/contact" className="cta-button">Get Your Free Quote</Link>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
